export const BENEFIT_TYPES_INDEX__SET_ALL = 'BENEFIT_TYPES_INDEX__SET_ALL';
export const BENEFIT_TYPES_INDEX__ADD_RESOURCE = 'BENEFIT_TYPES_INDEX__ADD_RESOURCE';
export const BENEFIT_TYPES_INDEX__UPDATE_RESOURCE = 'BENEFIT_TYPES_INDEX__UPDATE_RESOURCE';
export const BENEFIT_TYPES_INDEX__REMOVE_RESOURCE = 'BENEFIT_TYPES_INDEX__REMOVE_RESOURCE';
export const BENEFIT_TYPES_INDEX__CLEAR_ALL = 'BENEFIT_TYPES_INDEX__CLEAR_ALL';
